import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { naturaMutualisticaCoreRules } from './natura-mutualistica-core.rules';
import { naturaMutualisticaScopoRules } from './natura-mutualistica-scopo.rules';
import { naturaMutualisticaSchedaPrevalenzaA1B9Rules } from './natura-mutualistica-scheda-prevalenza-a1-b9.rules';
import { naturaMutualisticaSchedaPrevalenzaB6B7Rules } from './natura-mutualistica-scheda-prevalenza-b6-b7.rules';
import { naturaMutualisticaMutualitaPrevalenteRules } from './natura-mutualistica-mutualita-prevalente.rules';
import { naturaMutualisticaBilancioRules } from './natura-mutualistica-bilancio.rules';

export const NaturaMutualisticaRules: FormGroupRules = {
    ...naturaMutualisticaCoreRules,
    ...naturaMutualisticaScopoRules,
    ...naturaMutualisticaSchedaPrevalenzaA1B9Rules,
    ...naturaMutualisticaSchedaPrevalenzaB6B7Rules,
    ...naturaMutualisticaMutualitaPrevalenteRules,
    ...naturaMutualisticaBilancioRules,
};

export const NaturaMutualisticaFormValidators = [...Object.values(NaturaMutualisticaRules)];
